module.exports = __webpack_public_path__ + "img/bim (10).e015a563.png";